import { ElevatorBank } from '../../stacking-plan.model';
import { EDPElevatorBank } from './elevator-banks.model';

export class ElevatorBanksAdapter {
  adapt(edpElevatorBanks: EDPElevatorBank[]): ElevatorBank[] {
    return edpElevatorBanks.map(elevator => {
      return {
        elevatorBankId: elevator.id,
        elevatorTypeDesc: elevator.elevator_type_desc,
        elevatorBankName: elevator.elevator_bank_name,
        totalNumberOfFloors: elevator.total_number_of_elevators,
        baseStop: elevator.start_floor,
        firstStop: elevator.start_floor,
        lastStop: elevator.end_floor,
        elevatorBankCapacity: elevator.elevator_bank_capacity,
        elevatorBankCapacityUOM: elevator.elevator_bank_capacity_uom,
        adaCompliant: elevator.ada_compliant_f,
        elevatorBankNotes: elevator.elevator_bank_notes,
      };
    });
  }
}
